import { useEffect } from 'react';

const useRenderTiktokEmbeds = (slug: string, update: boolean) => {
  useEffect(() => {
    // Check if there are any TikTok embeds on the page
    const tiktokEmbeds = document.getElementsByClassName('tiktok-embed') || [];
    let script: any;

    // Attach script to the document head
    if (tiktokEmbeds.length > 0) {
      script = document.createElement('script');
      script.src = 'https://www.tiktok.com/embed.js';
      script.async = true;
      document.head.appendChild(script);
    }

    // Remove the script when the component unmounts
    return () => {
      if (script) {
        document?.head?.removeChild(script);
      }
    };
  }, [slug, update]);
};

export default useRenderTiktokEmbeds;
